import script from "./ComponentViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentViewer.vue?vue&type=script&setup=true&lang=js"

import "./ComponentViewer.vue?vue&type=style&index=0&id=62c117cf&lang=css"

const __exports__ = script;

export default __exports__